import React from "react";
import ReactDom from "react-dom/client";
import { FindKey } from "./FindKey";
import { PaymentForm } from "./PaymentForm";

(window as any).loadFindKey = function (ele: any, props: {}) {
  ReactDom.createRoot(ele).render(<FindKey {...props} />);
};

(window as any).loadPaymentForm = function (ele: any, props: {}) {
  ReactDom.createRoot(ele).render(<PaymentForm {...props} />);
};
